@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

<div class="card meeting-minute-view-card">
  <div class="card-header d-flex align-items-center gap-2">
    <h3 class="card-title mb-0">Meeting Minute</h3>
    @if (canModify) {
      <button type="button" class="btn btn-primary btn-sm ms-auto" (click)="goToEdit()">Edit meeting minute</button>
    }
  </div>

  <div class="card-body">
    <meeting-minute-form
      [meetingMinute]="meetingMinute"
      [meetingMinuteId]="meetingMinuteId"
      [readonlyForm]="true">
    </meeting-minute-form>
  </div>

  @if (canModify) {
    <div class="card-footer">
      <div class="d-flex justify-content-center align-items-center gap-2 my-2">
        <button type="button" class="btn btn-primary" (click)="goToEdit()">Edit meeting minute</button>
      </div>
    </div>
  }
</div>
